/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_nghost-%COMP%]{color:#666;display:flex;justify-content:center;align-items:center}[_nghost-%COMP%]:not(.empty){display:none!important}.empty[_nghost-%COMP%]{position:absolute;width:100%;height:100%;top:0;opacity:0}.empty[_nghost-%COMP%]:hover{opacity:1}"];
export { styles as styles };
